export const getColumnDefs = () => [
  {
    maxWidth: 50,
    checkboxSelection: true,
    cellRenderer: 'agGroupCellRenderer',
    field: 'supply_zone',
    headerName: '',
    rowGroup: true,
  },
  {
    field: 'terminal',
    headerName: '',
  },
]
